export enum ConnectionState {
  Alerting = 'alerting',
  Connected = 'connected',
  Disconnected = 'disconnected',
  Transmitting = 'transmitting'
}
